var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-course",staticStyle:{"padding":"0 15px"}},[_c('router-link',{staticClass:"f messages",staticStyle:{"color":"black"},attrs:{"to":"/mall/wechatMall/index?clearTabNav=true"}},[_c('span',{staticClass:"icon font_family icon-book",staticStyle:{"font-size":"28px","margin-right":"5px"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-21ba88da","hasScoped":true,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comm/MallCourse/index.vue
// module id = 1242
// module chunks = 72